<template>
  <div id="containt" style="height: 100%!important;">
    <el-tabs v-model="activeName" class="tab-box">
      <el-tab-pane label="列表" name="second">
        <div>
          <vxe-grid :stripe="true" border="default" show-overflow :row-config="{ isHover: true }"
                    ref="table-m1" v-bind="vxeOption"
                    @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle">

            <template #form>
              <div class="clearfix screen-btns" style=" border-bottom: 1px solid #ededed !important;">
                <div class="fl">
                  <vxe-button status="primary" v-if="parts_rules_company_setting" class="button-sty" icon="el-icon-timer"
                              @click="showCompanySettingsDialog = true">加急订单设置
                  </vxe-button>

                  <vxe-button status="primary" v-if="parts_rules_import" class="button-sty" icon="el-icon-bottom"
                              @click="$refs.excelUpload.show()">导入
                  </vxe-button>
                </div>
                <!-- <div class="fr" style="display: flex;" v-if="checkButton"> -->
                <div class="fr" style="display: flex;position: relative;">
                  <vxe-button status="warning" icon="el-icon-search" style="margin: 0 10px;" class="button-sty"
                              @click="searchEvent">搜索
                  </vxe-button>
                </div>
              </div>
              <el-collapse-transition name="fade">

                <vxe-form ref="form" class="screen-box" title-width="92px"
                          title-align="right" :data="formData" @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent">

                  <vxe-form-item title="服务商:" field="name">
                    <template v-slot>
<!--                      <site-pop-search :site-id.sync="formData.siteId"-->
<!--                                       :site-name.sync="formData.siteName"-->
<!--                                       :org-id.sync="formData.orgId"-->
<!--                                       :org-id-path.sync="formData.orgIdPath"-->
<!--                                       :org-name.sync="formData.orgName"-->
<!--                      />-->
                      <site-search :site-id.sync="formData.siteId"/>
                    </template>
                  </vxe-form-item>
                </vxe-form>
              </el-collapse-transition>

              <div class="goodsStatus">
                <div v-for="(item, index) in goodsStatusList" :key="index">
                  <div :class="{
											btnGoodsStatusBtn1: goodsStatusIndex == index,
											btnGoodsStatusBtn: goodsStatusIndex != index
										}" @click="changeGoodsStatus(item, index)">
                    <span>{{ item.name }}</span> <span v-show="item.num>0" class="num_color">{{ item.num }}</span>
                  </div>
                </div>
              </div>

            </template>

            <template #option="{row}">
              <div>
                <a v-if="parts_rules_setting" href="javascript:void(0);" class="a-link" @click="openSettings(row)">
                  <el-tooltip :enterable=false effect="dark" content="设置" placement="top"
                              popper-class="tooltip-skin">
                    <i class="el-icon-setting"/>
                  </el-tooltip>
                </a>

                <!--                <el-dropdown @command="handleCommand($event, row)" v-if="row.stat==2||row.stat==3||row.stat==5">-->
                <!--                  <span class="el-dropdown-link">-->
                <!--                    <i class="el-icon-arrow-down el-icon&#45;&#45;right" style="color:#00c4b3"></i>-->
                <!--                  </span>-->
                <!--                  <el-dropdown-menu slot="dropdown">-->
                <!--                    <el-dropdown-item>加急订单设置</el-dropdown-item>-->
                <!--                  </el-dropdown-menu>-->
                <!--                </el-dropdown>-->
              </div>
            </template>

            <template #qty="{row}">
              <span>{{Number(row.limitUrgerPartsQty) - Number(row.used) - Number(row.occupation)}}</span>
            </template>

            <template #pager>
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>
          </vxe-grid>
        </div>
      </el-tab-pane>
    </el-tabs>
    <company-settings-dialog v-if="showCompanySettingsDialog"
                             :visiable.sync="showCompanySettingsDialog"
    />
    <settingsDialog v-if="showCheckBillDialog"
                    @flushPage="getTableData"
                    :visiable.sync="showCheckBillDialog"
                    :id="rowData"></settingsDialog>
    <!--excel 模板导入 -->
    <excel-upload
      ref="excelUpload"
      title="配件规则导入"
      :url="api.snUser.partsRulesImportUrl"
      temp-url="/admin/sys-file/local/file/sitePartsRules.xlsx"
      @refreshDataList="getTableData"
    ></excel-upload>
  </div>
</template>

<script>
import {initVxeTable} from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'
import {mapGetters} from "vuex";
import checkboxButton from "element-ui/packages/checkbox-button";
import api from "@/api/projectApi";
import store from "@/store";
import SitePopSearch from "@/components/formItem/sitePopSearch.vue";
import settingsDialog from "./settingsDialog.vue";
import CompanySettingsDialog from "@/views/service/wangdian/attachment/companySettingsDialog.vue";
import ExcelUpload from "@/components/upload/excel.vue";
import SiteSearch from "@/components/formItem/siteSearch.vue";

export default {
  name: 'attachment',
  inject: ['reload'],
  components:
    {SiteSearch, ExcelUpload, CompanySettingsDialog, SitePopSearch, pager, settingsDialog},
  data() {
    return {
      rowData: '',
      showCheckBillDialog: false,
      showCompanySettingsDialog: false,

      parts_rules_setting: false,
      parts_rules_company_setting: false,
      parts_rules_import: false,

      drawer: false,
      total: 0,
      checkBillId: null,
      confirmNo: null,
      formLabelWidth: '80px',
      checkSubjectOption: [],
      initiateAppeal: false,
      isSite: null,
      requestParam: {
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 0,  // 页面数据量

        siteId: null,
        type: '待设置'
      },
      formData: {
        siteId: '',
        siteName: '',  // 网点名称,冗余字段
        orderNo: '',
        date: '',
        createTimeBegin: '',
        createTimeEnd: '',
        searchValue: '',
        orgId: null,
        orgName: null,
        orgIdPath: null,
        type: '待设置'
      },
      form2: {
        appealRemark: '',
        siteAnswerNote: '',
      },
      first: true,

      editViewDataUpdateFlag: false,
      showSelectStat: false,

      sfCheckBillExport: false,
      sfCheckBillImport: false,

      goodsStatusList: [],
      goodsStatusItem: "",//获取点击的元素名称
      goodsStatusIndex: 0,//:class做判断用，默认选中第一个
      activeName: 'second',
      dataId: 0,
      showEdit: false,
      vxeOption: {},
      fileList: [],
      pageSizes: [10, 20, 100],
      columns: [
        {type: 'checkbox', width: 30, title: '', resizable: false, fixed: 'left'},
        {width: 100, field: 'stat', fixed: 'right', title: '操作', showOverflow: true, slots: {default: 'option'}},
        {title: '登录账号', field: 'userAccount', width: 190,},
        {title: '服务商名称', field: 'userName', width: 150,},
        {title: '计划内配件起订金额', field: 'minPartsApplyAmount', width: 150,},
        {title: '计划外配件起订金额', field: 'minPartsApplyAmountTwo', width: 150,},
        {title: '配件订单最大申请数', field: 'maxPartsApplyQty', width: 150,},
        {title: '配件订单最大申请金额', field: 'maxPartsApplyAmount', width: 150,},
        {title: '每月加急配件数', field: 'limitUrgerPartsQty', width: 120,},
        {title: '加急已使用', field: 'used', width: 100,},
        {title: '加急已占用', field: 'occupation', width: 100,},
        {title: '加急可用数', field: 'qty', width: 100, slots: {default: 'qty'}},
        // {title: '创建人', field: 'createBy', width: 100,},
        // {title: '创建时间', field: 'createTime', width: 100,},
      ]
    };
  },
  watch: {
    'formData.date': {
      handler(newVal, oldVal) {
        if (newVal.length !== 0) {
          this.formData.createTimeBegin = newVal[0]
          this.formData.createTimeEnd = newVal[1]
        }
      },
      deep: true,
    },
    editViewDataUpdateFlag(n) {
      if (n) {
        this.editViewDataUpdateFlag = false
        this.flushed()
      }
    },
    activeName(newVal) {
      if (newVal === 'second' && this.editViewDataUpdateFlag) {
        this.flushed()
      }
    },
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
  },

  computed: {
    api() {
      return api
    },
    checkboxButton() {
      return checkboxButton
    },
    ...mapGetters(["permissions"]),
  },
  created() {
    this.parts_rules_setting = this.permissions['parts_rules_setting']
    this.parts_rules_import = this.permissions['parts_rules_import']
    this.parts_rules_company_setting = this.permissions['parts_rules_company_setting']

    const userInfo = store.getters.userInfo;
    if (userInfo.snUserId) {
      this.isSite = true;
    }
    console.log(this.checkButton, "this.checkButton");
  },
  mounted() {
    this.loadCheckSubjectOption()
    // this.loadGoodsStatusList(true)
  },
  methods: {
    toFilterData() {
            this.searchEvent();
     },
    checkBillCommit() {
      this.showCheckBillDialog = false

    },
    openSettings(row) {
      console.log(row, "设置");
      this.rowData = row.id
      this.showCheckBillDialog = true
    },
    // 切换tab到列表页
    changeTab() {
      this.activeName = 'second';
      this.showEdit = false
      this.flushed()
    },
    // 加载tab数据
    async loadGoodsStatusList() {
      await this.$http({
        url: api.snUser.partsRulesCountUrl,
        method: 'post',
        data: this.requestParam
      }).then(res => {
        this.goodsStatusList = res.data.data
        if (this.first) {
          if (this.goodsStatusList) {
            this.goodsStatusIndex = 0
            this.goodsStatusItem = this.goodsStatusList[this.goodsStatusIndex].name
          }
        }
        this.first = false
      })
    },

    loadCheckSubjectOption() {
      this.$http({
        url: api.basCheckSubject.getListUrl,
        method: 'post',
        data: {
          usable: 1,
          useWhere: 1
        }
      }).then(res => {
        this.checkSubjectOption = []
        res.data.data.forEach(item => {
          this.checkSubjectOption.push({
            label: item.name,
            value: item.id,
            feeAttributeId: item.feeAttributeId,
            feeAttributeName: item.feeAttributeName,
            standardAmount: item.standardAmount,
            isNeedSiteComplain: item.isNeedSiteComplain
          })
        })
      })
    },

    flushed() {
      // this.loadGoodsStatusList(false)
      this.$refs['table-m1'].commitProxy('reload');
    },

    editViewDataUpdate() {
      this.editViewDataUpdateFlag = true
    },

    // 选中的按钮
    changeGoodsStatus(item, index) {
      this.goodsStatusItem = item.name;//获取点击的元素
      this.goodsStatusIndex = index;//将点击元素的下标和：class中的作对比

      this.showSelectStat = (this.goodsStatusItem === '所有')
      this.requestParam.searchCount = false
      this.requestParam.current = 1
      this.$refs.pager.reset()  // 重置分页器
      this.requestParam.type = this.goodsStatusItem
      this.formData.type = this.goodsStatusItem
      this.getTableData()
    },

    // 加载table数据
    getTableData() {
      this.loadGoodsStatusList()
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: api.snUser.partsRulesPageUrl,
        param: this.requestParam,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData();
    },

    // 搜索
    searchEvent() {
      this.$objCopy(this.formData, this.requestParam)
      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.getTableData()
    },
  }
};
</script>
<style lang="scss">
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

::v-deep .vxe-grid .screen-btns {
  margin-bottom: 6px;
  border-bottom: 1px solid #ededed !important;
}

.vxe-grid .a-link {
  color: #00c4b3;
  margin-right: 0px !important;
}

// 弹窗过渡显示效果
// 进场时候过渡的开始状态和离场的结束状态
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

// 指定过渡的属性和时间，同样是进场和离场的过渡时间
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

// 进场时候过渡的结束状态和离场的开始状态
.fade-enter-to,
.fade-leave {
  opacity: 1;
}


// 选中的按钮

.goodsStatus {
  //按钮水平
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-content: space-between;
}

.btnGoodsStatusBtn {
  //白底按钮

  margin-right: 20px;
  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  text-align: center;
  background: #fff;
  padding: 5px;
}

::v-deep .el-drawer .el-drawer__body {
  padding: 0 16px;
  background-color: #fff;
  position: relative;
}

::v-deep .el-drawer .el-drawer__header {
  background-color: #fff;
}

.btnGoodsStatusBtn1 {
  //红底按钮

  margin-right: 20px;
  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  color: #409eff;
  text-align: center;
  border-bottom: 3px solid #409eff;
  padding: 5px;
}

.num_color {
  display: inline-block;
  margin-left: 5px;
  /* width: 15px; */
  font-size: 12px;
  padding: 4px;
  line-height: 7px;
  height: 12px;
  color: #409eff;
  border-radius: 4px 4px;
  background-color: #ddeaff;
}
</style>
